import { LoginWithPaypalComponent } from '@shared/components/login-with-paypal';
// since this is a child module with components that containtng HTML elements with ng attribute tags
// the CommonModule is to be used instead of the Browser Module.
import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, ModuleWithProviders, NO_ERRORS_SCHEMA } from '@angular/core';

// since datepicker is a form need formsmodule imported here or can't assign formcontrolname attribute
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialsModule } from '@app/material.module';

// CoreModule custom pipes
import * as Pipes from '@shared/components/custom-pipes';

// include the shared components to be used.

// datetime primeng picker
import { CalendarModule } from 'primeng/calendar';
import { DatepickerPrimeNgComponent } from '@shared/components/datepicker-primeng';

// alert component
import { AlertMessageComponent } from '@shared/components/alert-message';

// Modal Components
import { ModalComponent } from '@shared/components/modal-base';
import { ConfirmModalComponent } from '@shared/components/confirm-modal';

// validation message component
import { ValidationMessageComponent } from '@shared/components/validation-message';

// Overlay message component display
import { OverlayComponent } from '@shared/components/overlay-message';

// slide component
import { GlobalSelectorComponent } from '@shared/components/global-wb-selector';
import { OrderReceiptComponent } from '@shared/components/order-receipt/order-receipt.component';
import { PaymentRequestComponent } from '@shared/components/payment-request/payment-request.component';
import { MonitoringErrorHandler } from '@core/handlers/monitoring-error.handler';
import { LoggingService } from '@core/services/logging.service';
import { environment } from '@environments/environment';
import { RouterModule } from '@angular/router';
import { SafeStylePipe } from './custom-pipes/safe-style.pipe';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { PhoneFormatPipe } from './custom-pipes/phone-format.pipe';
import { CapitalizePipe } from './custom-pipes/capitalize.pipe';
import { TruncatePipe } from './custom-pipes/truncate.pipe';
import { SubstringPipe } from './custom-pipes/substring.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { A11yModule } from '@angular/cdk/a11y';
import { PazeCheckoutComponent } from './paze-checkout/paze-checkout.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    CommonModule,
    CalendarModule,
    FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
    ReactiveFormsModule,
    MaterialsModule,
    RouterModule,
    NgxMaskModule,
    A11yModule       
  ],
  declarations: [
    // do not declare components here if they are being included in the main app.module file to be called directly.
    // Put them in the exported array below instead
    AlertMessageComponent,
    DatepickerPrimeNgComponent,
    ConfirmModalComponent,
    ModalComponent,
    ValidationMessageComponent,
    OverlayComponent,
    Pipes.ReversePipe,
    Pipes.SafeHtmlPipe,
    Pipes.OrderArrayObjBy,
    Pipes.SortByDatePipe,
    Pipes.SortByCategoryId,
    Pipes.ConvertUtcToLocale,
    Pipes.TimeDeserializer,
    Pipes.SafeStylePipe,
    Pipes.IntegerPart,
    Pipes.DecimalPart,
    Pipes.PhoneFormatPipe,
    Pipes.CapitalizePipe,
    Pipes.TruncatePipe,
    Pipes.SubstringPipe,
    Pipes.PickupTimeFormatPipe,
    GlobalSelectorComponent,
    OrderReceiptComponent,
    LoginWithPaypalComponent,
    PaymentRequestComponent,
    FileUploadComponent,
    PazeCheckoutComponent],
  exports: [
    CommonModule,
    CalendarModule,
    NgxMaskModule,
    AlertMessageComponent,
    DatepickerPrimeNgComponent,
    ModalComponent,
    ValidationMessageComponent,
    ConfirmModalComponent,
    OverlayComponent,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    Pipes.ReversePipe,
    Pipes.SafeHtmlPipe,
    Pipes.OrderArrayObjBy,
    Pipes.SortByDatePipe,
    Pipes.SortByCategoryId,
    Pipes.ConvertUtcToLocale,
    Pipes.TimeDeserializer,
    Pipes.IntegerPart,
    Pipes.DecimalPart,
    Pipes.SafeStylePipe,
    Pipes.PhoneFormatPipe,
    Pipes.CapitalizePipe,
    Pipes.TruncatePipe,
    Pipes.SubstringPipe,
    Pipes.PickupTimeFormatPipe,
    GlobalSelectorComponent,
    OrderReceiptComponent,
    LoginWithPaypalComponent,
    PazeCheckoutComponent,
    PaymentRequestComponent,
    FileUploadComponent
  ],
  providers: [
    // providers
    {
      provide: LoggingService,
      useClass: environment.loggingServiceProvider
    },
    {
      provide: ErrorHandler,
      useClass: MonitoringErrorHandler
    },
    {
      provide: 'AppInsightsConfig',
      useValue: environment.appInsightsConfig
    },
    {
      provide: 'LogLevel',
      useValue: environment.defaultLogLevel
    }
  ]
})
export class SharedComponentsModule {}
